/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
  }
  onChange(event) {
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  applyDiscount(discountCode) {
    const applyButton = document.getElementById('apply-discount');
    const discountInput = document.getElementById('discount-code');
    
    // Show loading state
    if (applyButton) {
      applyButton.disabled = true;
      applyButton.style.cursor = 'not-allowed';
    }
    
    // Make AJAX request to apply the discount code
    fetch('/discount/' + discountCode, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      // Don't try to parse JSON since it's a 302 redirect
      // Update the cart dynamically without reload
      this.refreshCart();
    })
    .catch(error => {
      // Reset button state on error
      if (applyButton) {
        applyButton.disabled = false;
        applyButton.style.cursor = 'pointer';
      }
    });
  }

  refreshCart() {
    // Fetch the updated cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        // Update the cart display by refreshing the cart sections
        this.refresh();
        
        // Reset the discount button after cart update
        const applyButton = document.getElementById('apply-discount');
        const discountInput = document.getElementById('discount-code');
        
        if (applyButton) {
          applyButton.disabled = false;
          applyButton.style.cursor = 'pointer';
        }
        
        if (discountInput) {
          discountInput.value = '';
        }
      })
      .catch(error => {
        // Reset button state on error
        const applyButton = document.getElementById('apply-discount');
        if (applyButton) {
          applyButton.disabled = false;
          applyButton.style.cursor = 'pointer';
        }
        // Fallback to page reload if cart refresh fails
        location.reload();
      });
  }
  setupEventListeners() {
    this.removeProductEvent();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.termsCheckbox();
    this.notesToggleEvent();
    this.discountCodeEvent();
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  updateQuantity(line, quantity) {
    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }
        this.renderContents(parsedState, line, false);

        this.container.classList.remove('cart-disabled');

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
      });
  }
  refresh() {
    this.container.classList.add('cart-disabled');

    let sections = 'main-cart';

    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, false, true);

        this.container.classList.remove('cart-disabled');
      });
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  notesToggleEvent() {
    const notesToggle = document.querySelector('.notes-toggle');
    const notesContent = document.querySelector('.notes-content');

    if (notesToggle && notesContent) {
      notesToggle.addEventListener('click', (event) => {
        event.preventDefault();
        
        if (notesContent.style.display === 'none' || notesContent.style.display === '') {
          notesContent.style.display = 'block';
          notesToggle.querySelector('p').textContent = theme.strings.hideNote || 'Notiz ausblenden';
        } else {
          notesContent.style.display = 'none';
          notesToggle.querySelector('p').textContent = theme.strings.addNote || 'Notiz zur Bestellung hinzufügen';
        }
      });
    }
  }
  discountCodeEvent() {
    const applyButton = document.getElementById('apply-discount');
    const discountInput = document.getElementById('discount-code');

    if (applyButton && discountInput) {
      applyButton.addEventListener('click', (event) => {
        event.preventDefault();
        const discountCode = discountInput.value.trim();
        if (discountCode) {
          this.applyDiscount(discountCode);
        } else {
          alert('Please enter a discount code');
        }
      });

      discountInput.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          const discountCode = discountInput.value.trim();
          if (discountCode) {
            this.applyDiscount(discountCode);
          } else {
            alert('Please enter a discount code');
          }
        }
      });
    }

    // Add event listeners for remove discount buttons
    this.removeDiscountEvent();
  }

  removeDiscountEvent() {
    const removeButtons = document.querySelectorAll('.remove-discount-btn');
    
    removeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const discountCode = button.getAttribute('data-discount-code');
        if (discountCode) {
          this.removeDiscount(discountCode);
        }
      });
    });
  }

  removeDiscount(discountCode) {
    // Show loading state
    const removeButtons = document.querySelectorAll('.remove-discount-btn');
    removeButtons.forEach(button => {
      button.disabled = true;
      button.style.cursor = 'not-allowed';
    });

    // Use Shopify's cart update API to remove discount
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        'discount': ''
      })
    })
    .then(response => response.json())
    .then(cartData => {
      // Update the cart dynamically without reload
      this.refreshCart();
    })
    .catch(error => {
      console.error('Error removing discount:', error);
      // Reset button state on error
      const removeButtons = document.querySelectorAll('.remove-discount-btn');
      removeButtons.forEach(button => {
        button.disabled = false;
        button.style.cursor = 'pointer';
      });
      // Fallback to page reload if cart refresh fails
      location.reload();
    });
  }
  renderContents(parsedState, line, refresh) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      if (refresh) {
        if (parsedState[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }
      } else {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }

      this.removeProductEvent();
      this.notesToggleEvent();
      this.discountCodeEvent();
      this.removeDiscountEvent();

      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
      this.termsCheckbox();
    }));
  }
}
window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});